module.exports = __webpack_public_path__ + "img/empty-offer-2.d9bdacc9.png";